module.exports = __webpack_public_path__ + "assets/img/Jurong Lake Gardens.147b967e.jpg";